import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useFormStepCollectionContext } from 'Components/UI/Accounts/AccountApplication/AccountApplicationContext';
import { Skeleton } from '@material-ui/lab';
import SelectFieldStandardized from 'Components/ComponentLibrary/Components/Uncategorized/SelectField';

function StepPicklist({ classes, onChange }) {
  const {
    state: {
      steps, activeStep, disabled,
    },
  } = useFormStepCollectionContext();
  const stepOptions = steps?.resources()
    .list()
    .map((step, i) => ({
      isComplete: step.attr('completed') === 'true',
      value: i,
      name: step.attr('stepName'),
    })) || [];

  if (!steps) {
    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <Skeleton classes={{ root: classes.skeleton }} height={68} test="stepper-skeleton" />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <SelectFieldStandardized
          test="stepper-nav-picklist"
          variant="filled"
          disabled={disabled}
          shouldDisableOption={opt => {
            if (opt > 0) return !stepOptions[opt - 1].isComplete;
            return opt === activeStep;
          }}
          label={''}
          options={stepOptions}
          value={activeStep}
          onChange={(evt) => onChange(evt.target.value)}
        />
      </div>
    </div>
  );
}

StepPicklist.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(theme => ({
  root: {
    width: '100%',
  },
  container: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    margin: theme.spacing(1),
  },
  stepSelect: {
    flexGrow: 1,
    padding: theme.spacing(0.5),
    textAlign: 'center',
  },
  skeleton: {
    flexGrow: 1,
    borderRadius: theme.radius.md,
    padding: theme.spacing(0.5),
  },
  textWrapper: {
    padding: theme.spacing(0.5),
    display: 'flex',
    flexBasis: '12.5%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 16,
  },
  divider: {
    width: '100%',
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: 32,
    top: 0,
  },
}))(StepPicklist);
